<template>
  <div
    style="display: inline-block; margin-right: 0.7rem;"
    tabindex="0"
  >
    <div class="linha-vertical">
      <b-btn
        :id="target"
        variant="none"
        class="btn-primary btn-sm mr-50"
      >
        <feather-icon
          style="margin-right:0.25rem"
          icon="FilterIcon"
        />Filtros</b-btn>
      <b-popover
        id="filtroAdicionalBase"
        ref="popover"
        :target="target"
        triggers="click"
        :show.sync="popoverShow"
        placement="bottom"
        custom-class="multiselect-popover-filtro"
      >
        <div
          slot="title"
          style="text-align: center;"
        >
          <span
            style="vertical-align: sub"
          >Filtros</span>
          <b-button
            variant="none"
            class="close"
            @click="onClose"
          >
            <span aria-hidden="true">&times;</span>
          </b-button>
        </div>
        <slot
          name="conteudo-filtro-adicional"
        />
        <div
          v-if="showButton"
          style="display: contents;"
        >
          <b-btn
            variant="none"
            class="btn-primary btn-sm mr-50 ml-50"
            @click.prevent.stop="limpar()"
          >Limpar</b-btn>
          <b-btn
            variant="none"
            class="btn-primary btn-sm"
            @click="aplicar()"
          >Aplicar</b-btn>
        </div>
      </b-popover>
    </div>
  </div></template>

<style lang="scss">
.linha-vertical {
  height: 30px;/*Altura da linha*/
  border-right: 1px solid rgb(163 164 166 / 88%);/* Adiciona borda direita na div como ser fosse uma linha.*/
}

.multiselect-popover-filtro {
  min-width: 380px;
  max-width: 500px;
}

.multiselect-popover-filtro .arrow {
  visibility: hidden;
}

.multiselect-popover-filtro .popover-body {
  max-height: calc(70vh - 132px);
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar {
      width: 10px;
      background-color: #f5f5f5;
      }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #bfbfbf;
    }
}
</style>

<script>
export default {
  name: 'FiltroAdicionalBase',
  props: {
    target: {
      type: String,
      required: true,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      popoverShow: false,
    }
  },
  methods: {
    onClose() {
      this.popoverShow = false
    },
    limpar() {
      this.$emit('limpar')
    },
    aplicar() {
      this.$emit('aplicar-busca')
    },
  },
}
</script>
